export default __webpack_public_path__ + "b492977b122723a112358580a934ec03.jpg";